export const keyringContractAbi = [
  {
    type: "function",
    name: "checkCredential",
    stateMutability: "view",
    inputs: [
      { name: "entity_", type: "address" },
      { name: "policyId", type: "uint32" },
    ],
    outputs: [{ type: "bool" }],
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradingAddress",
        type: "address",
      },
      { internalType: "uint256", name: "policyId", type: "uint256" },
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "uint256", name: "validUntil", type: "uint256" },
      { internalType: "uint256", name: "cost", type: "uint256" },
      { internalType: "bytes", name: "key", type: "bytes" },
      { internalType: "bytes", name: "signature", type: "bytes" },
      { internalType: "bytes", name: "backdoor", type: "bytes" },
    ],
    name: "createCredential",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "policyId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "entity_",
        type: "address",
      },
    ],
    name: "entityExp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const
